<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <router-link :to="{ path: '/fair_prize/new'}">
        <el-button type="primary">添加奖品</el-button>
      </router-link>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="编号"></el-table-column>
        <el-table-column prop="name"
                         label="名称"></el-table-column>
        <el-table-column prop="admin_name"
                         label="添加人"></el-table-column>
        <el-table-column prop="created_at"
                         label="添加时间"></el-table-column>
        <el-table-column prop="updated_at"
                         label="修改时间"></el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="{ path: '/fair_prize/edit/'+scope.row.id}">
              <el-button type="text"
                         size="mini">修改
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       @click="onDelete(scope.row.id)"
                       v-if="scope.row.is_del">删除
            </el-button>
            <router-link :to="{ path: '/fair_prize/log/index/'+scope.row.id}">
              <el-button type="text"
                         size="mini">查看历史记录
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'



export default {
  mixins: [table],



  data () {
    return {
      table: [],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
    }
  },



  computed: Vuex.mapState({}),



  created () {
  },



  methods: {
    ...Vuex.mapActions([]),


    getTableData (params) {
      return request.page('getFairPrizeTable', params)
    },


    onDelete (fairid) {
      this.$confirm('你确定要删除奖品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('deleteFairPrize', fairid).then((res) => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/fair-prize/pages/FairPrizeIndex.vue